import React from 'react';

function Umamap() {
    return (
<>
<div className="album py-1">
        
        <div className="container">

            <div className="row">

    <iframe  width="520" height="400" className="iframe-fluid mb-3" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=Uma%20Hardware,%20XJPX+64V,%20More,%20Natna,%20West%20Bengal%20741122%20Natna+(Uma%20Hardware)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"> </iframe>
<iframe  width="520" height="400" className="iframe-fluid" src="https://www.google.com/maps/embed?pb=!4v1763546404134!6m8!1m7!1sJQ68kl4ohwKtna4Ksh4SBA!2m2!1d23.98587434210056!2d88.64774255176454!3f164.32381657706!4f2.811952500968829!5f1.464570357270703"   allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>

</div>
</div>


</>
);
}

export default Umamap;